import { render, staticRenderFns } from "./WPRichText.vue?vue&type=template&id=3701ba32&lang=pug&"
import script from "./WPRichText.vue?vue&type=script&lang=js&"
export * from "./WPRichText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports